import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedButtonColourType} from '../../models/shared-button-colours';
import {SharedButtonShapeType} from '../../models/shared-button-shape';

@Component({
  selector: 'app-shared-button',
  templateUrl: './shared-button.component.html',
  styleUrls: ['./shared-button.component.scss'],
  standalone: false,
})
export class SharedButtonComponent implements OnInit, OnChanges {
  @Input() fill = false;
  @Input() disabled = false;
  @Input() selected = false;
  @Input() header = false;
  @Input() subHeader = false;
  @Input() colour: SharedButtonColourType = 'secondary';
  @Input() shape: SharedButtonShapeType = 'square';
  @Input() id?: string;

  @Output() readonly buttonClicked: EventEmitter<Event> = new EventEmitter<Event>();

  buttonId: string;

  ngOnInit(): void {
    this.syncButtonId();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id']) {
      this.syncButtonId();
    }
  }

  onClick(event: Event): void {
    if (this.disabled) {
      event.stopImmediatePropagation();
      event.preventDefault();
    } else {
      this.buttonClicked.emit(event);
    }
  }

  private syncButtonId(): void {
    this.buttonId = this.id || this.buttonId || `btn-${crypto.randomUUID()}`;
  }
}
